<div class="language-selection-container">
  <mat-form-field [class.openned]="isMenuOpened">
    <mat-select
      disableRipple
      [(value)]="selectLangCode"
      (openedChange)="onOpenedChange($event)"
      (selectionChange)="onSelectLang($event)"
    >
      <mat-select-trigger class="mat-select-trigger">
        <div>
          <img
            *ngIf="selectedLanguage()?.flag"
            [src]="selectedLanguage()?.flag"
            alt="{{ selectedLanguage()?.label }} flag"
            width="20"
            height="14"
            style="vertical-align: middle; margin-right: 8px"
          />
          {{ selectedLanguage()?.label || '' | translate }}
        </div>
        <mat-icon class="mat-select-trigger__icon" [class.focus]="isMenuOpened">
          expand_more
        </mat-icon>
      </mat-select-trigger>

      <mat-option *ngFor="let lang of languages" [value]="lang.id">
        <img
          [src]="lang.flag"
          alt="{{ lang.label }} flag"
          width="20"
          height="14"
          style="vertical-align: middle; margin-right: 8px"
        />
        <span>{{ lang.label | translate }}</span>
      </mat-option>
    </mat-select>
  </mat-form-field>
</div>
